wbApp.controller('AttendanceLogMpsvReportParamsCtrl', ['$scope', '$q', 'rfidCardsSvc', '$translate', 'groupSvc',
function ($scope, $q, rfidCardsSvc, $translate, groupSvc) {

    $scope.modelOrig = angular.copy($scope.model);

    $scope.studentIsSelected = false;
    $scope.employeeIsSelected = false;

    $scope.detailIsUnchanged = function (data) {
        return !$scope.studentIsSelected || !$scope.employeeIsSelected || !!$scope.isLoadingData;
    };

    function loadData(fromDate, toDate) {

        if (!fromDate || !toDate) {
            return;
        }

        $scope.isLoadingData = true;
        $scope.studentIsSelected = false;
        $scope.employeeIsSelected = false;
        $scope.students = rfidCardsSvc.getRegisteredStudentsForPeriodAsync(fromDate, toDate);
        $scope.employees = rfidCardsSvc.getRegisteredEmployeesForPeriodAsync(fromDate, toDate);

        $q.all([$scope.students.$promise, $scope.employees.$promise]).then(function () {
            $scope.isLoadingData = false;
        });
    }

    function updateDetailError(shouldMessageBePresent, msg) {
        if (shouldMessageBePresent) {
            // remove msg
            if (!!$scope.detailError &&
                !!$scope.detailError.errors &&
                $scope.detailError.errors.length > 0) {
                var idx = _.findIndex($scope.detailError.errors, { message: msg });
                if (idx !== -1) {
                    $scope.detailError.errors.splice(idx, 1);
                }
                if ($scope.detailError.errors.length === 0) {
                    $scope.detailError = null;
                }
            }
        } else {
            // add msg
            if (!$scope.detailError) {
                $scope.detailError = { errors: [{ message: msg }] };
            } else {
                if (!$scope.detailError.errors) {
                    $scope.detailError.errors = [{ message: msg }];
                } else {
                    if (!_.find($scope.detailError.errors, { message: msg })) {
                        $scope.detailError.errors.push({ message: msg });
                    }
                }
            }
        }
    }

    $scope.detailError = {
        errors: [
            { message: $translate.instant('TXT_MSG_SELECT_STUDENTS_TO_INCLUDE_IN_REPORT') },
            { message: $translate.instant('TXT_MSG_SELECT_EMPLOYEES_TO_INCLUDE_IN_REPORT') }
        ]
    }

    $scope.studentsGridSelectionChanged = function () {

        $scope.studentIsSelected = !!_.find($scope.students, { isSelected: true });
        var msg = $translate.instant('TXT_MSG_SELECT_STUDENTS_TO_INCLUDE_IN_REPORT');

        updateDetailError($scope.studentIsSelected, msg);
    };

    $scope.employeesGridSelectionChanged = function () {
        $scope.employeeIsSelected = !!_.find($scope.employees, { isSelected: true });
        var msg = $translate.instant('TXT_MSG_SELECT_EMPLOYEES_TO_INCLUDE_IN_REPORT');

        updateDetailError($scope.employeeIsSelected, msg);
    }

    loadData($scope.fromDate, $scope.toDate);

    $scope.detailTabs = [
    {
        title: 'TXT_LBL_STUDENTS',
        template: "rfid-cards/attendance-log/attendance-log-mpsv-attendance-report-students-tab.html"
    },
    {
        title: "TXT_LBL_EMPLOYEES",
        template: "rfid-cards/attendance-log/attendance-log-mpsv-attendance-report-employees-tab.html"
    }];

    $scope.rangeChanged = function (fromDate, toDate) {
        loadData(fromDate, toDate);
    }

    $scope.groups = groupSvc.getAllAsync();

    $scope.studentsGridFilterOptions = {
        groups: [],
        filterText: "",
        filterFunction: function (value, index) {
            if (!$scope.studentsGridFilterOptions.groups.length) {
                return true;
            }

            return _.intersection(value.groups, $scope.studentsGridFilterOptions.groups).length > 0;
        }
    };

    $scope.employeesGridFilterOptions = {
        filterText: ""
    };

    $scope.studentsGridOptions = {
        sortInfo: { fields: ['fullName'], directions: ['asc'] },
        columnDefs: [
            { field: 'deviceSerialNumber', displayName: "TXT_LBL_DEVICE_SERIAL_NUMBER", width: '90px' },
            { field: 'fullName', displayName: "TXT_HUMAN_NAME", sort: 'humanName' },
            { field: 'parentFullName', displayName: "TXT_LBL_PARENT"},
            { field: 'email', displayName: "TXT_LBL_EMAIL", width: '180px' },
            { field: 'phone', displayName: "TXT_LBL_PHONE", cellFilter: "phone", width: '130px' },
            { field: 'groups', displayName: "TXT_LBL_GROUPS", hidden: true },
        ],
        noCommandColumn: true,
        multiSelect: true,
        disableExport: true
    };

    $scope.employeesGridOptions = {
        sortInfo: { fields: ['fullName'], directions: ['asc'] },
        columnDefs: [
            { field: 'deviceSerialNumber', displayName: "TXT_LBL_DEVICE_SERIAL_NUMBER", width: '90px' },
            { field: 'fullName', displayName: "TXT_HUMAN_NAME", sort: 'humanName' },
            { field: 'groups', displayName: "TXT_LBL_GROUPS", hidden: true }],
        noCommandColumn: true,
        multiSelect: true,
        disableExport: true
    };

    $scope.isSavingXls = false;
    $scope.isSavingXlsx = false;

    $scope.onDetailSave = function (model, compatibility) {

        if (compatibility) {
            $scope.isSavingXls = true;
        } else {
            $scope.isSavingXlsx = true;
        }

        function success(data) {
            $scope.isSavingXls = false;
            $scope.isSavingXlsx = false;
            $scope.$hide();
            $scope.reportGenerated(data);
        }

        function error(data) {
            $scope.isSavingXls = false;
            $scope.isSavingXlsx = false;
            $scope.detailError = data;
        }

        var students = _.map(_.filter($scope.students, { isSelected: true }),
            function (s) { return { studentID: s.studentID, deviceSerialNumber: s.deviceSerialNumber }; });
        var employees = _.map(_.filter($scope.employees, { isSelected: true }),
            function (e) { return { employeeID: e.employeeID, deviceSerialNumber: e.deviceSerialNumber }; });

        var group = (!!$scope.studentsGridFilterOptions.groups && $scope.studentsGridFilterOptions.groups.length === 1)
            ? $scope.studentsGridFilterOptions.groups[0]
            : null;

        var res = null;
        
        if ($scope.isNursery) {
            res = rfidCardsSvc.getMPSVNurseryAttendanceReportAsync(
                students,
                employees,
                $scope.fromDate,
                $scope.toDate,
                compatibility,
                group);

        } else {
            res = rfidCardsSvc.getMPSVAttendanceReportAsync(
                students,
                employees,
                $scope.fromDate,
                $scope.toDate,
                compatibility,
                group);
        }

        res.$promise.then(success, error);
    }
}]);
